"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Well2["default"];
  }
});
require("./Well.scss");
var _Well2 = _interopRequireDefault(require("react-bootstrap/lib/Well"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Well.js
// module id = 303
// module chunks = 25